import { toast } from 'react-toastify'
import { RestClient, PipelineClient } from '@visorpro/client'

export const API_TOKEN_KEY = 'token'
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'
export const PIPELINE_API_URL =
    process.env.REACT_APP_PIPELINE_API_URL || 'http://localhost:3001'

export const visorPRORestClient = new RestClient(API_URL)
export const visorPROPipelineClient = new PipelineClient(PIPELINE_API_URL)

export const loadAPIToken = () => {
    const authRecordJson = localStorage.getItem(API_TOKEN_KEY)
    if (authRecordJson) {
        try {
            const authRecord = JSON.parse(authRecordJson) as AuthRecord
            if (authRecord.api_url == API_URL && authRecord.token) {
                return authRecord.token
            }
        } catch (error) {
            console.log('Error retrieving auth token: ', error)
        }
    }
}

export interface AuthRecord {
    api_url: string
    token: string
}

export const logBackendError = (e: any, message: string) => {
    toast.error(message)
}
